module.exports = __webpack_public_path__ + "img/xdd.5d25bbd0.png";